const budgetData = [
	[
		{
			id: 'turnover',
			dictionaryId: 'turnover',
			title: {
				da: 'Omsætning',
				kl: 'Kaaviiaartitat',
			},
			unit: 'kr',
			initialValue: 36000
		},
	],
	[
		{
			id: 'total-expenses',
			dictionaryId: '',
			title: {
				da: 'Udgifter',
				kl: 'Aningaasartuutit',
			},
			unit: 'kr',
			initialValue: 0
		},
		{
			id: 'fixed-expenses',
			dictionaryId: 'fixed-expenses',
			title: {
				da: 'Faste udgifter',
				kl: 'Aningaasartuutit ataavartut',
			},
			unit: 'kr',
			initialValue: 0
		},
		{
			id: 'loans',
			dictionaryId: '',
			title: {
				da: 'Renter og afdrag af lån',
				kl: 'Taarsigassarsiat',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		},
		{
			id: 'rent-and-utilities',
			dictionaryId: '',
			title: {
				da: 'Husleje, el, vand og varme',
				kl: 'Inimut akiliutissaq, kallerup innera, imeqarneq kiassarnerlu',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		},
		{
			id: 'website',
			dictionaryId: '',
			title: {
				da: 'Website',
				kl: 'Nittartagaq',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		},
		{
			id: 'salaries',
			dictionaryId: '',
			title: {
				da: 'Løn',
				kl: 'Akissarsiat',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		},
		{
			id: 'variable-expenses',
			dictionaryId: 'variable-expenses',
			title: {
				da: 'Variable udgifter',
				kl: 'Aningaasartuutit allanngorartut',
			},
			unit: 'kr',
			initialValue: 0
		},
		{
			id: 'production',
			dictionaryId: '',
			title: {
				da: 'Produktion',
				kl: 'Nioqqutissiorneq',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		},
		{
			id: 'marketing',
			dictionaryId: '',
			title: {
				da: 'Markedsføring',
				kl: 'Nittarsaaneq',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		},
		{
			id: 'other',
			dictionaryId: '',
			title: {
				da: 'Øvrige',
				kl: 'Allallu',
			},
			unit: 'kr',
			initialValue: 0,
			isExpandedBudget: true
		}
	],
	[
		{
			id: 'profit',
			dictionaryId: 'profit',
			title: {
				da: 'Overskud',
				kl: 'Sinneqartoorutit',
			},
			unit: 'kr',
			initialValue: 0
		}
	],
	[
		{
			id: 'liquidity',
			dictionaryId: 'liquidity',
			title: {
				da: 'Likviditet',
				kl: 'Akiliisinnaassuseqarneq',
			},
			unit: 'kr',
			initialValue: 0
		}
	]
];

module.exports = {
	budgetData
};